<template>
  <div>
    <a-card>
      <span slot="title" class="title">{{ `${titlepage.toUpperCase()} LIST` }}</span>
      <div slot="extra">
        <a-input-search
          placeholder="input search text"
          style="width: 300px"
          v-model="search"
        />
      </div>
      <a-tabs :activeKey="activetab" @change="handleTab">
        <a-tab-pane style="margin:auto" key="process">
          <template slot="tab">
            <span>Need Process</span>
            <a-badge
              key="badge"
              class="m-badge m-badge-small"
              :count="list_process.length"
              :numberStyle="{ backgroundColor: 'red' }"
              v-if="list_process.length > 0"
            >
            </a-badge>
          </template>
          <div class="loading" v-if="loading.process">
            <a-spin :spinning="loading.process" tip="Loading..."></a-spin>
          </div>
          <a-table
            v-else
            :columns="column_process"
            :dataSource="process_list"
            id="id_pfi"
            size="small"
            :pagination="pagination"
            bordered
            :scroll="{ x: 100 }"
          >
            <a
              slot="no"
              slot-scope="item"
              @click="handleLink(item.jenis, item.id)"
              >{{ item.no }}</a
            >
            <span slot="value" slot-scope="amount">
              <CurrencyJustified
                v-if="amount.value"
                :key="amount.key"
                :currencyValue="amount.currency"
                :valueNumber="amount.value"
              />
              <div v-else style="text-align:center;width:100%">-</div>
            </span>
            <span slot="balance" slot-scope="amount">
              <CurrencyJustified
                v-if="amount.sisa"
                :key="amount.key"
                :currencyValue="amount.currency"
                :valueNumber="amount.sisa"
              />
              <div v-else style="text-align:center;width:100%">-</div>
            </span>
            <span slot="update_by" slot-scope="item">
              <span v-if="item.tlc_updated">
                {{ item.tlc_updated }} /
                {{
                  item.date_updated
                    ? moment(item.date_updated, getDateTimeStandartFormat).format(
                        getDefaultDateFormat
                      )
                    : "-"
                }}
              </span>
              <span v-else>
                -
              </span>
            </span>
            <span slot="centang" slot-scope="item">
              <!-- <a-popconfirm
                :key="item.key"
                title="Are you sure to change ?"
                @confirm="changeActionItem(item)"
                ok-text="Yes"
                cancel-text="No"
              > -->
                <a-button :key="item.key" type="primary" @click="handlemodal(item)"
                :disabled="item.proses=='disabled'"
                >
                  Process
                </a-button>
              <!-- </a-popconfirm> -->
            </span>
          </a-table>
        </a-tab-pane>
        <a-tab-pane tab="BKK Release" key="release">
          <div class="loading" v-if="loading.release">
            <a-spin :spinning="loading.release" tip="Loading..."></a-spin>
          </div>
          <a-table
            v-else
            :columns="column_release"
            :dataSource="release_list"
            id="id_ep1"
            size="small"
            :pagination="pagination"
            bordered
            :scroll="{ x: 100 }"
          >
            <a
              slot="no"
              slot-scope="item"
              @click="handleLink(item.jenis, item.id)"
              >{{ item.no }}</a
            >
            <a
              slot="no_trans"
              slot-scope="item"
              >{{ item.no_trans }}</a
            >
            <span slot="value" slot-scope="amount">
              <CurrencyJustified
                v-if="amount.value"
                :key="amount.key"
                :currencyValue="amount.currency"
                :valueNumber="amount.value"
              />
              <div v-else style="text-align:center;width:100%">-</div>
            </span>
            <span slot="remaining_release" slot-scope="item">
                <CurrencyJustified
                  v-if="item.remaining_balance"
                  :key="item.key"
                  :currencyValue="item.currency"
                  :valueNumber="item.remaining_balance"
                />
                <div v-else style="text-align:center;width:100%">-</div>
              </span>
            <span slot="update_by" slot-scope="item">
              <span v-if="item.tlc_updated">
                {{ item.tlc_updated }} /
                {{
                  item.date_updated
                    ? moment(item.date_updated, getDateTimeStandartFormat).format(
                        getDefaultDateFormat
                      )
                    : "-"
                }}
              </span>
              <span v-else>
                -
              </span>
            </span>
            <span slot="no_bkk" slot-scope="item">
              <a v-if="item.bkk_id"
              @click="handleLink('bkk', item.bkk_id)"
              >{{ item.no_bkk }}</a
              >
              <span v-else>-</span>
            </span>
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </a-card>
    <a-modal
      v-model="processModal"
      :maskClosable="false"
    >
      <span slot="title">
        Process BKK Release
      </span>
      <a-form-model ref="modalForm" :model="modalForm" :rules="rulesForm">
        <a-form-model-item label="No"
        :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }"
        prop="no" ref="no">
          <a-input
            disabled
            class="m-width-full"
            autocomplete="off"
            v-model="modalForm.no"
          ></a-input>
        </a-form-model-item>
        <a-form-model-item label="Description"
        :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }"
        prop="description" ref="description">
          <a-textarea
            disabled
            class="m-width-full"
            autocomplete="off"
            v-model="modalForm.description"
          ></a-textarea>
        </a-form-model-item>
        <a-form-model-item label="Value"
        :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }"
        prop="val" ref="val">
          <a-input-number
            :min="0"
            class="m-width-full m-text-align right"
            @keydown="onlyNumber"
            :formatter="
              (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
            v-model="modalForm.val"
          ></a-input-number>
        </a-form-model-item>
        <a-form-model-item label="Note"
        :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }"
        prop="note" ref="note">
          <a-textarea
            class="m-width-full"
            autocomplete="off"
            v-model="modalForm.note"
          ></a-textarea>
        </a-form-model-item>
      </a-form-model>
      <template slot="footer">
        <a-button key="back" @click="handleCloseModal"> Cancel </a-button>
        <a-button key="submit" type="primary" @click="handleOkModal" :loading="loadingmodalsave">
          Save
        </a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
import GlobalMethod from "@/mixins/GlobalMethod.js";
export default {
  name: "BKKRelease",
  mixins: [GlobalMethod],
  data() {
    let checkPending;
    let checkValue = (rule, value, callback) => {
      clearTimeout(checkPending);
      if (!value) {
        return callback(new Error("Please input the value"));
      }

      const limit = parseFloat(this.modalForm.maxval);
      if (value > limit) {
        callback(new Error(`Value must be less than ${this.modalForm.maxval}`));
      } else {
        callback();
      }
    };
    return {
      activetab: "process",
      typepage: "",
      titlepage: "",
      list_release: [],
      list_process: [],
      loading: {
        release: false,
        process: false,
      },
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 20,
        size: "small",
      },
      search: "",
      processModal: false,
      loadingmodalsave: false,
      modalForm : {
        no : null,
        description : null,
        val : null,
        note: null,
      },
      rulesForm :{
        no: [
          {
            required: false,
          },
        ],
        description: [
          {
            required: false,
          },
        ],
        val: [
          {
            required: true,
            trigger: "blur",
            validator: checkValue,
          },
        ],
        note:[
          {
            required: false,
          },
        ]
      }
    };
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getDateTimeStandartFormat",
      "getTypePage",
    ]),
    column_process() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "#",
          key: "number",
          dataIndex: "number",
          width: this.getscreen ? 20 : 50,
          align: "center",
        },
        {
          title: "No",
          width: this.getscreen ? 100 : 250,
          key: "no",
          scopedSlots: { customRender: "no" },
        },
        {
          title: "Description",
          key: "deskripsi",
          dataIndex: "deskripsi",
          width: this.getscreen ? 180 : 250,
        },

        {
          title: "Value",
          key: "value",
          width: this.getscreen ? 100 : 200,
          scopedSlots: { customRender: "value" },
        },
        {
          title: "Remaining Balance",
          key: "balance",
          width: this.getscreen ? 100 : 200,
          scopedSlots: { customRender: "balance" },
        },
        {
          title: "Action",
          key: "centang",
          fixed: "right",
          width: this.getscreen ? 50 : 100,
          align: "center",
          scopedSlots: { customRender: "centang" },
        },
      ];
      return kolom;
    },
    column_release() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "#",
          key: "number",
          dataIndex: "number",
          width: this.getscreen ? 20 : 50,
          align: "center",
        },
        {
          title: "No BKK Release",
          width: this.getscreen ? 100 : 250,
          key: "no_trans",
          scopedSlots: { customRender: "no_trans" },
        },
        {
          title: "No Transaksi",
          width: this.getscreen ? 100 : 250,
          key: "no",
          scopedSlots: { customRender: "no" },
        },
        {
          title: "Description",
          key: "deskripsi",
          dataIndex: "deskripsi",
          width: this.getscreen ? 180 : 250,
        },
        {
          title: "Value",
          key: "value",
          width: this.getscreen ? 100 : 200,
          scopedSlots: { customRender: "value" },
        },
        {
          title: "Remaining Balance Release",
          key: "remaining_release",
          width: this.getscreen ? 100 : 200,
          scopedSlots: { customRender: "remaining_release" },
        },
        {
          title: "Update By",
          key: "update_by",
          width: this.getscreen ? 65 : 150,
          align: "center",
          scopedSlots: { customRender: "update_by" },
        },
        {
          title: "Note",
          key: "note",
          dataIndex: "catatan",
          width: this.getscreen ? 180 : 250,
        },
        {
          title: "No BKK",
          key: "no_bkk",
          width: this.getscreen ? 65 : 150,
          align: "left",
          scopedSlots: { customRender: "no_bkk" },
        },
      ];
      return kolom;
    },
    release_list() {
      let output = this.list_release;

      if (this.search && this.activetab == "release") {
        output = output.filter(
          (obj) =>
            obj.no.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            moment(obj.date_updated)
              .format(this.getDefaultDateFormat)
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            obj.tlc_updated.toLowerCase().indexOf(this.search.toLowerCase()) >=
              0 ||obj.no_trans.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.value.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.deskripsi.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }
      return output;
    },
    process_list() {
      let output = this.list_process;

      if (this.search && this.activetab == "process") {
        output = output.filter(
          (obj) =>
            obj.no.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.value.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.deskripsi.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }
      return output;
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    moment,
    async fetchData() {
      if (this.activetab == "release") {
        this.loading.release = true;
      } else {
        this.loading.process = true;
      }
      this.typepage = this.$route.meta.page_type;
      this.titlepage = this.$route.meta.page_title ? this.$route.meta.page_title : this.$route.meta.page_type;
      const release = axios({
        method: "get",
        url: this.$serviceUrl + "Bkk_release",
        params: {
          tab: "bkk release",
          jenis: this.typepage,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        console.log(err);
      });

      const proses = axios({
        method: "get",
        url: this.$serviceUrl + "Bkk_release",
        params: {
          tab: "need process",
          jenis: this.typepage,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        console.log(err);
        this.loading.release = false;
        this.loading.process = false;
      });

      return await new Promise((resolve, reject) => {
        axios
          .all([
            release.catch((err) => {
              console.log(err);
              return null;
            }),
            proses.catch((err) => {
              console.log(err);
              return null;
            }),
          ])
          .then((response) => {
            this.list_release = response[0] ? response[0].data.data : [];
            this.list_process = response[1] ? response[1].data.data : [];
            if (this.list_process.length > 0) {
              for (let index = 0; index < this.list_process.length; index++) {
                let col = [
                  {
                    ...this.list_process[index],
                    key: "a" + (index + 1),
                    number: index + 1,
                    dana_sts: false,
                  },
                ];
                this.list_process[index] = col[0];
              }
            }
            if (this.list_release.length > 0) {
              for (let index = 0; index < this.list_release.length; index++) {
                let col = [
                  {
                    ...this.list_release[index],
                    key: "b" + (index + 1),
                    number: index + 1,
                  },
                ];
                this.list_release[index] = col[0];
              }
            }
            this.loading.release = false;
            this.loading.process = false;
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    handleTab(val) {
      this.activetab = val;
      this.search = "";
      if (this.activetab == "release") {
        this.loading.release = true;
      } else {
        this.loading.process = true;
      }
      this.fetchData();
    },
    handleLink(jenis, id_) {
      let manifest = "";
      if (jenis == "pi") {
        manifest = "PiManifest";
      } else if (jenis == "umpp") {
        manifest = "UmppManifest";
      } else if (jenis == "umpd") {
        manifest = "umpd_manifest";
      } else if (jenis == "klaimpd") {
        manifest = "manifestKlaimPd";
      } else if (jenis == "klaimpp") {
        manifest = "manifestKlaimPp";
      }else if (jenis == "klaimdirektur") {
        manifest = "manifestDirectur";
      }else if (jenis == "bkk") {
        manifest = "bkkManifestKeu";
      } else if (jenis == "klaim_cc") {
        manifest = "manifestKlaimCC";
      } else if (jenis == "klaim_cc_pd") {
        manifest = "manifestCCKlaimPd";
      } else if (jenis == "klaim_cc_pp") {
        manifest = "manifestKlaimCCPp";
      }
       else {
        manifest = "lapUmppManifest";
      }
      const route = this.$router.resolve({
        name: manifest,
        params: { id: id_ },
      });
      window.open(route.href, "_blank");
    },
    changeActionItem() {
      this.$refs.modalForm.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }
          
        if (this.modalForm.val > this.modalForm.maxval) {
          this.displayMessageValue("error-basic", "Value is grather than remaining balance!");
        }else{
        this.loadingmodalsave = true;
          axios({
            method: "post",
            url: this.$serviceUrl + "bkk_release",
            processData: false,
            data: {
              tlc: this.getAuth.username,
              jenis_transaksi: this.typepage,
              id_transaksi: this.modalForm.id,
              catatan: this.modalForm.note,
              value: this.modalForm.val,
            },
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "application/json",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
          .then((response) => {
            this.handleCloseModal();
            this.displayMessage("success-save");
            Event.$emit("trigfetchnotif", true);
            this.fetchData();
            this.activetab = "release";
            this.loadingmodalsave = false;
          })
          .catch((err) => {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
            this.loadingmodalsave = false;
          });
        }
      });
    },
    handlemodal(item){
      this.processModal = true;
      this.modalForm = {
        id: item.id,
        no: item.no,
        description: item.deskripsi,
        val: item.sisa,
        maxval: Number(item.value),
        note: null,
      };
    },
    resetfieldModal(){
      this.modalForm = {
        id: null,
        no: null,
        description: null,
        val: null,
        maxval: 0,
        note: null,
      };
    },
    handleCloseModal(){
      this.resetfieldModal();
      this.processModal = false;
    },
    handleOkModal(){
      this.changeActionItem();
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  text-transform: capitalize;
}
</style>
